import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@shared/ui/styles/tokens.css';
import { App } from '@app/App';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
